import React from 'react';
import LinkButton from '../Button/LinkButton';
import { useAppContext } from '../../Services/AppContext';
import NetteApiClient from '../../Services/NetteApiClient';
import { Theme } from '../../Enums/Theme.enum';
import useMeddiApp from '../../Hooks/useMeddiApp';
import { Case } from '../../graphql/graphql';
import useLoading from '../../Modules/Base/Hooks/useLoading';
import { checkWizardExist } from '../../Modules/Wizard/Services/wizard.service';
import { useDisclose } from '../../Modules/Modal/Hooks/useDisclose';
import CloseCaseButtonStatic from './CloseCaseButtonStatic';
import CloseCaseButtonDynamic from './CloseCaseButtonDynamic';

export interface CloseCaseButtonProps {
	className?: string;
	caseId: string;
	patientId: string;
	onCaseClose?: () => void;
	caseData?: Case;
}

const CloseCaseButton: React.FC<CloseCaseButtonProps> = props => {
	const {
		isOpen: isOpenStatic,
		onOpen: onOpenStatic,
		onClose: onCloseStatic,
	} = useDisclose(false);
	const {
		isOpen: isOpenDynamic,
		onOpen: onOpenDynamic,
		onClose: onCloseDynamic,
	} = useDisclose(false);
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { isCallActive, hangUpCall } = useMeddiApp();
	const { redirectCaseList } = useAppContext();

	const resolveCall = () => {
		if (isCallActive()) {
			hangUpCall();
		}
	};

	const onCaseClose = () => {
		props.onCaseClose?.();

		if (redirectCaseList) {
			NetteApiClient.get(redirectCaseList);
		}
	};

	const onDynamicCaseClose = () => {
		onCloseDynamic();
		onCaseClose();
	};

	const onStaticCaseClose = () => {
		onCloseStatic();
		onCaseClose();
	};

	const handleOpen = async () => {
		setIsLoading(true);

		const wizardExist = await checkWizardExist('solve-case', {
			caseId: props.caseId,
		});

		if (wizardExist) {
			onOpenDynamic();
		} else {
			onOpenStatic();
		}

		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<>
			<LinkButton
				onClick={handleOpen}
				title='base.shared.closeCase'
				theme={Theme.RED}
				firstUpper
			/>
			{isOpenStatic && (
				<CloseCaseButtonStatic
					{...props}
					onCaseClose={onStaticCaseClose}
					onClose={onCloseStatic}
					resolveCall={resolveCall}
				/>
			)}
			{isOpenDynamic && (
				<CloseCaseButtonDynamic
					{...props}
					onCaseClose={onDynamicCaseClose}
					onClose={onCloseDynamic}
					resolveCall={resolveCall}
				/>
			)}
		</>
	);
};

export default CloseCaseButton;
